

import axios from "axios";

import { API_URL } from "./conection";

export const getForms = async () => {
  try {
    const res = await axios.get(`${API_URL}/api/forms`);
    return res.data;
  } catch (error) {
    console.error("Error cargando forms:", error);
    return [];
  }
};

export const getFormById = async (templateId) => {
  try {
    const res = await axios.get(`${API_URL}/api/forms/${templateId}`);
    return res.data;
  } catch (error) {
    console.error("Error cargando formById:", error);
    return null;
  }
};

export const updateForm = async (templateId, data) => {
  try {
    const res = await axios.put(`${API_URL}/api/update-forms/${templateId}`, data);
    return res.data; // { modifiedCount: ... }
  } catch (error) {
    console.error("Error actualizando form:", error);
    return null;
  }
};